import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, Signal } from '@angular/core';
import { EqualPipe } from '@lx/shared/ui/pipes';
import { LoadingService } from '@lx/shared/ui/loading-spinner';
import { Observable } from 'rxjs';
import { QTLiteStoreSignalsAdapterService } from '../../services/qt-lite-store-signals-adapter.service';
import { QuoteOutputProduct, QuoteStore } from '../../store';
import { CardContainerComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { PriceLabelComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { OperationKey } from '../../constants';

@Component({
  standalone: true,
  selector: 'lx-supplements',
  templateUrl: './supplements.component.html',
  styleUrls: ['./supplements.component.scss'],
  imports: [CommonModule, CardContainerComponent, PriceLabelComponent, EqualPipe],
})
export class SupplementsComponent implements OnInit {
  feesAndSupplements$: Observable<QuoteOutputProduct[]> | undefined;
  currency: Signal<string | undefined>;
  protected loading: Signal<boolean | undefined>;

  private readonly quoteStore = inject(QuoteStore);
  private readonly qtLiteStoreSignalsAdapterService = inject(QTLiteStoreSignalsAdapterService);
  private readonly loadingService = inject(LoadingService);

  ngOnInit(): void {
    this.feesAndSupplements$ = this.quoteStore.feesAndSupplements$;
    this.currency = this.qtLiteStoreSignalsAdapterService.selectedCurrency;
    this.loading = this.loadingService.areAllOperationsLoading([OperationKey.prices, OperationKey.extras]);
  }
}
